export default __webpack_public_path__ + "static/media/PostgreSQL-WindowsTaskScheduler-Properties08.0c404f5a.png";